import {checkHasBarInText} from 'modules/wineshops-list/helpers';
import {useMemo} from 'react';

export const useICheckHasBarInText = (hasTwoSchedule: boolean, text: string) => {
    return useMemo(() => {
        return hasTwoSchedule && checkHasBarInText(text);
    }, [hasTwoSchedule, text]);
};
